import { render, staticRenderFns } from "./ScoreTrackingDetailList.vue?vue&type=template&id=2624b463&"
import script from "./ScoreTrackingDetailList.vue?vue&type=script&lang=js&"
export * from "./ScoreTrackingDetailList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTrackingDetailList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports